import { SummarizerConfig } from '../../types/summarizer';

export const notionSummarizerConfig: SummarizerConfig = {
  // Basic identification
  id: 'notion-summarizer',
  title: 'Notion Page Summarizer',
  description: 'Summarize Notion pages and documents with AI-powered analysis',
  version: '1.0.0',

  // Categorization
  category: 'document',
  tags: ['notion', 'wiki', 'notes', 'documentation', 'collaboration'],

  // Input configuration
  inputs: {
    file: {
      enabled: false, // Notion pages are accessed via URL
    },
    url: {
      enabled: true,
      placeholder: 'Enter Notion page share link',
      validation: /(notion\.(so|site)|www\.notion\.so)/,
      examples: [
        'https://www.notion.so/page-title-abc123',
        'https://username.notion.site/page-title-xyz789',
        'https://notion.so/workspace/page-def456',
      ],
      helpText: 'Share your Notion page publicly and paste the link to get an instant AI summary.',
      showExamples: true,
      showHelpText: true,
    },
    text: {
      enabled: true,
      placeholder: 'Or paste the Notion page content here',
      maxLength: 100000,
      minLength: 100,
      rows: 10,
    },
  },

  // Output features
  outputs: {
    summary: true,
    chat: true,
    repurpose: true,
    mindmap: true,
    translation: true,
    keyPoints: true,
    transcript: false,
    download: true,
    share: true,
  },

  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'notion',
    timeout: 30000,
  },

  // UI customization
  ui: {
    primaryColor: '#000000',
    secondaryColor: '#ffffff',
    icon: '📝',
    theme: 'light',
  },

  // Validation rules
  validation: {
    required: true,
    minSize: 0,
    maxSize: 0,
    allowedDomains: ['notion.so', 'notion.site'],
    blockedDomains: [],
  },

  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false,
  },

  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01',
};
